import React from 'react';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
`;

const PatternContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1;
`;

const PatternElement = styled.div`
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: ${float} 6s ease-in-out infinite;
  
  &:nth-child(1) {
    width: 80px;
    height: 80px;
    top: 20%;
    left: 10%;
    animation-delay: 0s;
  }
  
  &:nth-child(2) {
    width: 60px;
    height: 60px;
    top: 60%;
    right: 15%;
    animation-delay: 2s;
  }
  
  &:nth-child(3) {
    width: 100px;
    height: 100px;
    bottom: 20%;
    left: 20%;
    animation-delay: 4s;
  }
  
  &:nth-child(4) {
    width: 40px;
    height: 40px;
    top: 40%;
    right: 30%;
    animation-delay: 1s;
  }
  
  &:nth-child(5) {
    width: 70px;
    height: 70px;
    top: 80%;
    right: 40%;
    animation-delay: 3s;
  }
`;

const BrazilianPattern = () => {
  return (
    <PatternContainer>
      <PatternElement />
      <PatternElement />
      <PatternElement />
      <PatternElement />
      <PatternElement />
    </PatternContainer>
  );
};

export default BrazilianPattern;